export default __webpack_public_path__ + "static/media/indonesia.5eccbc57.svg";